import { Box } from '@mui/material';
import React from 'react';
import NavBar from '../../components/NavBar/NavBar';
import RegistrationForm from '../../components/RegistrationForm/RegistrationForm';

const Register: React.FC = () => {
    return (
        <Box>
            <NavBar />
            <RegistrationForm />
        </Box>
    );
};

export default Register;